module.exports = __webpack_public_path__ + "img/anquan3-2.3819b330.jpg";